<template>
	<v-container>
		<form>
			<!-- Mandator -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-show="mandatorVisible"
						v-model="formState.selectedMandators"
						:items="formItems.mandator"
						:error-count="mandatorErrorCount"
						:error-messages="mandatorErrorMessage"
						:search-input.sync="searchMandators"
						hide-selected
						label="Mandator"
						persistent-hint
						chips
						return-object
					></v-autocomplete>
				</v-col>
			</v-row>

			<!-- order date -->
			<v-row>
				<!-- Order Date Pickers -->
				<v-col cols="12" md="6" v-show="dateFromVisible">
					<v-menu
						ref="menuFrom"
						v-model="menuFrom"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateFromTemp"
								:rules="[rules.dateFormat]"
								label="Date from"
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateFromFinal"
							no-title
							@input="menuFrom = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>

				<v-col cols="12" md="6" v-show="dateTillVisible">
					<v-menu
						ref="menuTill"
						v-model="menuTill"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="formState.dateTillTemp"
								:rules="[rules.dateFormatTill]"
								label="Date till"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateTillFinal"
							no-title
							@input="menuTill = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<!-- Product group-->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="productSkuVisible"
						v-model="formState.selectedProducts"
						:items="formItems.products"
						:search-input.sync="searchProducts"
						hide-selected
						label="Product SKU"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
				<!-- Product SKU -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="productGroupVisible"
						v-model="formState.selectedSkuGroups"
						:items="formItems.skuGroups"
						:search-input.sync="searchSkuGroups"
						hide-selected
						label="Product group"
						multiple
						persistent-hint
						chips
						return-object
					>
					</v-autocomplete>
				</v-col>
			</v-row>

			<!-- Sales channel / Service provider -->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedSalesChannels"
						:items="formItems.salesChannels"
						hide-selected
						label="Sales Channel"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
				<!--SP-->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedServiceProviders"
						:items="formItems.serviceProviders"
						hide-selected
						label="Service Provider"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
			</v-row>

			<!-- Order State / Rule Name -->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedStates"
						:items="formItems.states"
						hide-selected
						label="Order State"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
				<!--Rule name-->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedRuleNames"
						:items="formItems.ruleNames"
						hide-selected
						label="Rule Names"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
			</v-row>

			<!-- Rule Type / Coupon code -->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedRuleTypes"
						:items="formItems.ruleTypes"
						hide-selected
						label="Rule Type"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
				<!--Coupon code-->
				<v-col cols="12" md="6">
				</v-col>
			</v-row>
			<v-btn
				class="searchButton ml-5"
				color="primary"
				@click="submitData"
			> {{ txt.showData }}
			</v-btn>

			<v-btn
				class="searchButton ml-5"
				@click="submitExcel"
				disabled
			> {{ txt.excelExport }}
			</v-btn>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'couponCodeFilter',
	data() {
		return {
			txt: {
				showData: 'Show Data',
				excelExport: 'Excel Export',
				csvExport: 'CSV Export',
			},
			appNameShort: 'cc',
			formItems: {
				mandator: [],
				products: [],
				skuGroups: [],
				serviceProviders: [],
				salesChannels: [],
				states: [],
				ruleNames: [],
				ruleTypes: [],
			},
			formState: {
				selectedMandators: [],
				dateFromTemp: new Date().toISOString().substr(0, 10),
				dateFromFinal: new Date().toISOString().substr(0, 10),
				dateTillTemp: new Date().toISOString().substr(0, 10),
				dateTillFinal: new Date().toISOString().substr(0, 10),
				selectedProducts: [],
				selectedSkuGroups: [],
				selectedSalesChannels: [],
				selectedServiceProviders: [],
				selectedStates: [],
				selectedRuleNames: [],
				selectedRuleTypes: [],
			},
			rules: {
				dateFormat: () => this.dateFromCorrect || 'Date is not valid. YYYY-MM-DD',
				dateFormatTill: () => this.dateTillCorrect || 'Date is not valid. YYYY-MM-DD',
			},
			mandatorVisible: true,
			mandatorErrorCount: 0,
			mandatorErrorMessage: '',
			searchMandators: null,

			dateFromVisible: true,
			dateTillVisible: true,
			menuFrom: false,
			menuTill: false,

			productSkuVisible: true,
			searchProducts: null,
			productGroupVisible: true,
			searchSkuGroups: null,

		}
	},
	watch: {
		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
				this.notEmptyMandator()
			},
		},
		'formState.selectedMandators': {
			handler() {
				// only allow one mandator before filling the filters and empty selected regions
				if (this.formState.selectedMandators.length > 1) {
					this.popFirstMandator(this.formState.selectedMandators)
					return
				}
				this.resetSelectedFilters()
				this.notEmptyMandator()
				if (this.formState.selectedMandators[0]) {
					// this.getMissingDataDate(this.formState.selectedMandators[0].value)
				}
				this.getProductSku(this.formState.selectedMandators)
				this.getSkuPartOne(this.formState.selectedMandators)
				this.getSalesChannel(this.formState.selectedMandators)
				this.getServiceProvider(this.formState.selectedMandators)
				this.getOrderStates(this.formState.selectedMandators)
				this.getRuleNames(this.formState.selectedMandators)
				this.getRuleTypes(this.formState.selectedMandators)
			},
		},
		'formState.dateFromTemp': {
			handler() {
				this.parseDate(this.formState.dateFromTemp)
			},
		},
		'formState.dateFromFinal': {
			handler() {
				this.setDateAsFinal(this.formState.dateFromFinal)
			},
		},
		'formState.dateTillTemp': {
			handler() {
				this.parseTillDate(this.formState.dateTillTemp)
			},
		},
		'formState.dateTillFinal': {
			handler() {
				this.setTillDateLikePicker(this.formState.dateTillFinal)
			},
		},
		'formState.selectedProducts': {
			handler() {
				this.productOrSku()
			},
		},
		'formState.selectedSkuGroups': {
			handler() {
				this.productOrSku()
			},
		},
	},
	methods: {
		async getMandators() {
			try {
				// eslint-disable-next-line no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/mandator`)
				this.formItems.mandator = r.data
			} catch (e) {
				console.log(e)
			}
		},
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator
				this.mandatorVisible = false
			}
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
			}
		},
		resetSelectedFilters() {
			this.formState.selectedProducts = []
			this.formState.selectedSkuGroups = []
		},
		allowedDates(val) {
			const d1 = new Date(val)
			const d2 = new Date()
			return d1 < d2
		},
		parseDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length === 3
				&& dateSplitted[0].length === 4
				&& dateSplitted[1].length === 2
				&& dateSplitted[2].length === 2
				&& date.length === 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				// eslint-disable-next-line eqeqeq
				if (dateISOString != 'Invalid Date') {
					this.formState.dateFromFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateFromTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateFromCorrect = true
					this.menuFrom = false
					return true
				}
			}
			this.dateFromCorrect = false
			return false
		},
		parseTillDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length == 3
				&& dateSplitted[0].length == 4
				&& dateSplitted[1].length == 2
				&& dateSplitted[2].length == 2
				&& date.length == 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				if (dateISOString != 'Invalid Date') {
					this.formState.dateTillFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateTillTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateTillCorrect = true
					this.menuTill = false
					return true
				}
			}
			this.dateTillCorrect = false
			return false
		},
		setDateAsFinal(dateInDatePicker) {
			this.formState.dateFromTemp = dateInDatePicker
		},
		setTillDateLikePicker(dateInDatePicker) {
			this.formState.dateTillTemp = dateInDatePicker
		},
		async getProductSku(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/sku?installationId=${mandators}`)
				this.formItems.products = r.data
				if (r.data.length <= 0) this.formItems.products.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getSkuPartOne(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/sku-part-one?installationId=${mandators}`)
				this.formItems.skuGroups = r.data
				if (r.data.length <= 0) this.formItems.skuGroups.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getSalesChannel(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/sales-channel?installationId=${mandators}`)
				this.formItems.salesChannels = r.data
				if (r.data.length <= 0) this.formItems.salesChannels.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getServiceProvider(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/service-provider?installationId=${mandators}`)
				this.formItems.serviceProviders = r.data
				if (r.data.length <= 0) this.formItems.serviceProviders.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getOrderStates(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/order-state?installationId=${mandators}`)
				this.formItems.states = r.data
				if (r.data.length <= 0) this.formItems.states.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getRuleNames(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/rule-name?installationId=${mandators}`)
				this.formItems.ruleNames = r.data
				if (r.data.length <= 0) this.formItems.ruleNames.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		async getRuleTypes(selectedMandators) {
			try {
				const mandators = selectedMandators.value
				if (mandators === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/coupon-code/rule-type?installationId=${mandators}`)
				this.formItems.ruleTypes = r.data
				if (r.data.length <= 0) this.formItems.ruleTypes.push('No data.')
			} catch (e) {
				console.log(e)
			}
		},
		productOrSku() {
			if (
				this.formState.selectedProducts.length == 0
				&& this.formState.selectedSkuGroups.length == 0
			) {
				this.productSkuVisible = true
				this.productGroupVisible = true
			}
			if (
				this.formState.selectedProducts.length !== 0
				&& this.formState.selectedSkuGroups.length == 0
			) {
				this.productSkuVisible = true
				this.productGroupVisible = false
			}
			if (
				this.formState.selectedProducts.length == 0
				&& this.formState.selectedSkuGroups.length !== 0
			) {
				this.productSkuVisible = false
				this.productGroupVisible = true
			}
		},
		submitData() {
			const request = {
				dateFrom: this.formState.dateFromFinal,
				dateTill: this.formState.dateTillFinal,
				selectedMandators: this.formState.selectedMandators,
				selectedProducts: this.formState.selectedProducts,
				selectedSkuGroups: this.formState.selectedSkuGroups,
				selectedSalesChannels: this.formState.selectedSalesChannels,
				selectedServiceProviders: this.formState.selectedServiceProviders,
				selectedOrderStates: this.formState.selectedStates,
				selectedRuleNames: this.formState.selectedRuleNames,
				selectedRuleTypes: this.formState.selectedRuleTypes,
			}
			this.$emit('submit', request)
		},
		submitExcel() {
			console.log('Here2')
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
		})
	},
}
</script>

<style scoped>

.filterContainer {
	padding: 0px !important;
}

</style>
